import React, { useState, Fragment, useEffect, useCallback } from 'react';
import {Col,Row, Container} from 'react-bootstrap';
import classes from '../WebsiteManagement/websiteManagement.module.css';
import classesX from '../Dashboard/dashboard.module.css'
import AdminNavbar from '../navbar/adminNavbar';
import AddPackage from './view/addPackage';
import AddPackageCategoryAndStyle from './view/addPackageCategoryAndStyle';
import PackageList from './view/packageList';
import ItineraryList from './view/itineraryList';
import DaywiseItineraryEditor from '../daywiseItinerary/DaywiseItineraryEditor';
import pm from './packageManagement.module.css';

const PackageManagement = (props)=>{
    const [active,updateActive] = useState('1');
    const [daywiseEditRequest, setDaywiseEditRequest] = useState({ id: null, n: 0 });
    const [packageEditRequest, setPackageEditRequest] = useState({ id: null, n: 0 });
    const selectTab = useCallback((id) => {
        updateActive(id);
        const scrollHost = document.querySelector('[data-admin-scroll]');
        if (scrollHost) {
            scrollHost.scrollTop = 0;
        }
    }, []);
    const openDaywiseEditor = useCallback((itineraryId) => {
        if (itineraryId != null) {
            setDaywiseEditRequest({ id: itineraryId, n: Date.now() });
        }
        selectTab('6');
    }, [selectTab]);
    const openPackageEditor = useCallback((holidayId) => {
        if (holidayId != null) {
            setPackageEditRequest({ id: holidayId, n: Date.now() });
        }
        selectTab('1');
    }, [selectTab]);
    useEffect(() => {
        const scrollHost = document.querySelector('[data-admin-scroll]');
        if (scrollHost) {
            scrollHost.scrollTop = 0;
        }
    }, [active]);
    const items = [
        {id:"1",type:"Add Package"},
        {id:"3",type:"Itinerary List"},
        {id:"4",type:"Package List"},
        {id:"5",type:"Add Package Category And Style"},
        {id:"6",type:"Day-wise Itinerary"}
    ]
 
    return(
        <Fragment> 
           <AdminNavbar/>
            <h1 className={classesX.Heading}>Holiday Management</h1>  
        <Container fluid className={`p-0 pl-2 ${pm.pageShell}`}>
            <Row className="mx-0"> 
                <Col lg={12} md={12} className={`${classes.Response2} ${pm.colShell}`}>
                    <div className={pm.tabBarHost}>
                        <ul className={`${pm.tabBar} ${active === '6' ? pm.tabBarFlush : ''}`}>
                            {items.map((item) => (
                                <li
                                    key={item.id}
                                    onClick={() => {
                                        if (item.id === '6' && active !== '6') {
                                            setDaywiseEditRequest({ id: null, n: 0 });
                                        }
                                        if (item.id === '1' && active !== '1') {
                                            setPackageEditRequest({ id: null, n: 0 });
                                        }
                                        selectTab(item.id);
                                    }}
                                    className={active === item.id ? pm.tabActive : pm.tab}
                                >
                                    {item.type}
                                </li>
                            ))}
                            {active === '6' ? (
                                <li onClick={() => selectTab('4')} className={pm.tabBack}>
                                    Back
                                </li>
                            ) : null}
                        </ul>
                    </div>
                </Col>
                <Col lg={12} md={12} className={`${classes.Response} ${pm.colShell}`}>
                    <div className={active === '6' ? pm.contentWide : pm.contentDefault}>
                        {
                            active==="1"?(
                                <AddPackage
                                    editHolidayId={packageEditRequest.id}
                                    editHolidayNonce={packageEditRequest.n}
                                />
                            ):
                            active==="3"?<ItineraryList onEditDaywise={openDaywiseEditor}/>:
                            active==="4"?<PackageList onEditPackage={openPackageEditor}/>:
                            active==="5"?<AddPackageCategoryAndStyle/>:
                            active==="6"?(
                                <DaywiseItineraryEditor
                                    editItineraryId={daywiseEditRequest.id}
                                    editItineraryNonce={daywiseEditRequest.n}
                                />
                            ):null 
                        }   
                    </div>
                </Col>
            </Row>
        </Container>
        </Fragment>
    )
}

export default PackageManagement;